import { useNavigate } from 'react-router-dom'
import { Button } from 'reactstrap'

export default function SearchButton({ searchId }) {
  //console.log(`SearchButton rendered: ${searchId}`)

  const navigate = useNavigate()

  function runSearch(theSearchId) {
    navigate(`/search/${theSearchId}`)
  }

  return <Button data-cy={`search-results-run-button-${searchId}`} color="success" size="sm" onClick={() => runSearch(searchId)}>Run</Button>
}